<template>
  <div>

  <Preloader v-show="!initializationDone" text="loading..."></Preloader>

    <v-card v-if="initializationDone" flat class="mt-0" style="background: rgb(178, 221, 180)">
      <v-container>
    <v-layout row>
    <v-flex xs4 md4 pa-3>
      <div class="pa-1">
        <div class="mb-3">
          <img src="./images/user_circle.png" style="max-width: 80px; height: auto; float: left; margin-right: 20px" />
          <span v-if="userProfile.name" style="font-weight: bold; font-size: 1.2em">{{ userProfile.name }}</span>
        </div>
        <v-btn v-show="!thisIsMyself && !iAmFollowingThisUser" color="primary" dark @click="doFollow()">Follow</v-btn>
        <v-btn v-show="!thisIsMyself && iAmFollowingThisUser" color="success" dark @click="doUnFollow()">Following</v-btn>

      </div>
    </v-flex>
    <v-flex xs8 md8 pa-5>
      <div class="mx-auto" style="max-width: 375px">
        <!-- <div class="text-center" v-if="thisIsMyself">My Collections</div> -->
        <!--<div class="text-center" v-if="!thisIsMyself">Address: <small>{{ userAddress }}</small></div>-->
        <div class="text-center pa-3" style="background-color: rgb(231, 227, 227); border-radius: 5px;" v-if="userProfile.description">{{ userProfile.description }}</div>
      </div>
    </v-flex>
  </v-layout>


    </v-container>
    </v-card>



  <v-container grid-list-md v-if="initializationDone">
    <v-layout v-show="userHasProfile === false"
      align-center
      justify-center
    >
      <v-flex
        xs12
        sm8
        md4
      >

      This user does not have a 3Box account. He/she can go to <a href="https://www.3box.io/hub" target="_blank">here</a> to create one.

      </v-flex>
    </v-layout>

    <v-card v-if="followingList"
      class="mx-auto my-3 text-center"
      >
      <v-card-title style="background: #EDEDED;">
        <v-layout row>
        <v-flex xs6 style="text-align: left">
        <span style="font-size: 0.8em; font-weight: bold">Connections:</span>
      </v-flex>
       <v-flex xs6>
        <div style="float: right"><v-btn color="success" dark @click.stop="searchModalOpen = true">Collector Search</v-btn></div>
      </v-flex>
    </v-layout>
      </v-card-title>
      <v-card-text>
        <div v-if="!followingList.length" class="my-3">Not following anybody</div>
        <div class="mt-4">
        <UserSummary
        v-for="(item, i) in followingList"
        :address="item"
      ></UserSummary>
    </div>
      </v-card-text>
    </v-card>


    <v-card class="pa-3">
    <v-layout v-show="userHasProfile" wrap>
      <v-flex class="pa-3"
        v-for="(item, i) in NFTList"
        :key="i"
        md4 sm6 xs12
      >

      <NFTCard
        :info = "item"
        :myaddress = "myAddress"
        :mynftlist = "NFTList"
      >
      </NFTCard>


      </v-flex>
    </v-layout>
  </v-card>
  </v-container>

  <!-- Begin Dialog Form -->
  <v-layout justify-center>
    <v-dialog v-model="searchModalOpen" persistent max-width="600px">

      <v-card>
        <v-card-title>
          <span class="headline">Collector Search</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form
              ref="searchUserForm"
              v-model="searchUserForm.valid"
            >
              <v-text-field
                outlined clearable
                v-model="searchUserForm.searchAddress"
                :rules="searchUserForm.rules.searchAddress"
                label="Address (0x.....)"
                required
              ></v-text-field>


        <div class="text-center">

          <v-btn
            :disabled="!searchUserForm.valid"
            color="success"
            class="mr-4"
            @click="doCollectorSearch"
          >
            Search
          </v-btn>

          <!--
          <v-btn
            color="info"
            @click="searchModalOpen = false"
          >
            Cancel
          </v-btn>
        -->

        </div>

        <div class="text-center my-4" v-show="searchUserForm.notFound !== null">
          <v-alert type="warning" v-show="searchUserForm.notFound === false" >Sorry, can't find this collector on this site</v-alert>
          <div v-show="searchUserForm.notFound === true" class="my-4">
            <div class="my-3">User Found.</div>
            <v-btn color="success" dark @click.stop="visitUserPage(searchUserForm.searchAddress)">Visit Profile</v-btn>
          </div>
        </div>

            </v-form>

          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="searchModalOpen = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
   <!-- End Dialog Form -->

  <!-- Begin Notification Bar -->
  <v-snackbar
    top
    :color="notificationBar.type"
    v-model="notificationBar.show"
  >
    {{ notificationBar.message }}
    <v-btn text @click="notificationBar.show = false">
      Close
    </v-btn>
  </v-snackbar>
  <!-- End Notification Bar -->

  </div>
</template>

<script>
import NFTCard from "@/components/NFTCard"
import Preloader from "@/components/Preloader"
import UserSummary from "@/components/UserSummary"
import { config } from '@/config'

export default {
  data: () => ({
    loading: true,
    initializationDone: false,
    userProfile: null,
    myProfile: null,
    myFollowingList: [],
    thisIsMyself: false,
    iAmFollowingThisUser: false,
    userHasProfile: null,
    NFTList: [],
    searchModalOpen: false,
    userData: {
      foo: null
    },
    followingList: null,
    notificationBar: {
      show: false,
      type: 'success', // 'success', 'error'
      message: ''
    },
    searchUserForm: {
      valid: true,
      searchAddress: null,
      notFound: null,
      rules: {
        searchAddress: [
          v => !!v || 'Address is required',
        ],
      },
    },
  }),
  computed: {
    userAddress: function () {
      if ('userAddress' in this.$route.params) {
        const address = this.$route.params.userAddress
        if (address == this.$store.state.myAddress) {
          this.thisIsMyself = true
        }
        else {
          this.thisIsMyself = false
        }
        return address
      }
      else {
        this.thisIsMyself = true
        const address = this.$store.state.myAddress
        // console.log('this is myself: ' + this.$store.state.myAddress)
        return address
      }
    },

    myAddress: function () {
      return this.$store.state.userAddress || localStorage.getItem(config.localStorageKey.login)
    },

    box: function () {
      return this.$store.state.box
    },

    appSpace: function () {
      return this.$store.state.appSpace
    },

  },
  components: {
    Preloader,
    NFTCard,
    UserSummary
  },
  methods: {

    async init() {
      this.initializationDone = false
      console.log('my Address: ' + this.myAddress)
      const myProfile = await this.box.public.all()
      console.log('myProfile')
      console.log(myProfile)
      this.myProfile = myProfile
      await this.getMyfollowingList()
      await this.getUserProfile()
      if (this.userHasProfile) {
        await this.getUserNFTList()
        await this.getUserData()
        this.initializationDone = true
      }
      else {
        this.initializationDone = true
      }
    },

    async getMyfollowingList() {
      const followingKey = config.usrKeys.following
      // this.myFollowingList = []
      if (followingKey in this.myProfile) {
        const list = JSON.parse(this.myProfile[followingKey])
        console.log(list)
        this.myFollowingList = JSON.parse(this.myProfile[followingKey])
        console.log('myFollowingList')
        console.log(this.myFollowingList)
      }
      const cleanUserAddress = this.userAddress.toLowerCase()
      if (this.myFollowingList.includes(cleanUserAddress)) {
        console.log('yes, i am already following this user')
        this.iAmFollowingThisUser = true
      }
      else {
        console.log('no, i am not following this user')
        this.iAmFollowingThisUser = false
      }
    },

    async getUserProfile() {
      this.userHasProfile = null
      this.userProfile = await window.Box.getProfile(this.userAddress)
      console.log(this.userProfile)
      if (Object.entries(this.userProfile).length > 0) {
        this.userHasProfile = true
        const followingKey = config.usrKeys.following
        if (followingKey in this.userProfile) {
          this.followingList = JSON.parse(this.userProfile[followingKey])
        }
        else {
          this.followingList = []
        }
      }
      else {
        this.userHasProfile = false
      }
      console.log(this.userProfile)
    },

    async getUserData() {
      console.log('getUserData')
      // this.userData.foo = await this.appSpace.public.get('foo')
      // console.log(this.userData.foo)
    },

    async getUserNFTList() {
      this.NFTList = [];
      console.log('userAddress: ' + this.userAddress)

      const apiURL = config.openSeaAPI.url.getAssets
      console.log(apiURL)

      try {
        const params = {
          owner: this.userAddress
        }
        const headers = config.openSeaAPI.headers
        const res = await axios.get(apiURL, { params: params, headers: headers })
        // console.log(res.data)
        for (let item of res.data.assets) {
          this.NFTList.push(item)
        }
        console.log(this.NFTList)
      } catch (err) {
        console.log(err)
        this.showNotification('error', 'Error occurred!')
      } finally {
      }

    },

    async doCollectorSearch() {
      console.log('doCollectorSearch')
      this.searchUserForm.notFound = null
      // this.searchUserForm.searchAddress = this.searchUserForm.searchAddress.toLowerCase()
      const profile = await window.Box.getProfile(this.searchUserForm.searchAddress)
      console.log(profile)
      if (Object.entries(profile).length == 0) {
        this.searchUserForm.notFound = false
      }
      else {
        this.searchUserForm.notFound = true
      }
    },

    visitUserPage(address) {
      this.searchModalOpen = false
      const cleanAddress = address.toLowerCase()
      this.$router.push({ name: 'user', params: {userAddress: cleanAddress} })
    },

    async doFollow() {
      const followingKey = config.usrKeys.following
      const cleanAddress = this.userAddress.toLowerCase()
      if (!this.iAmFollowingThisUser) {
        this.myFollowingList.unshift(cleanAddress)
        const followingListStr = JSON.stringify(this.myFollowingList)
        await this.box.public.set(followingKey, followingListStr)
      }
      this.init()
    },

    async doUnFollow() {
      const followingKey = config.usrKeys.following
      const cleanAddress = this.userAddress.toLowerCase()
      const newList = []
      for (var i=0; i<this.myFollowingList.length; i++) {
        let item = this.myFollowingList[i]
        if (typeof item === 'string' || item instanceof String) {
          if (item !== cleanAddress) {
            newList.push(item)
          }
        }
      }
      const followingListStr = JSON.stringify(newList)
      await this.box.public.set(followingKey, followingListStr)
      this.init()
    },

    showNotification(type, message) {
      this.notificationBar.message = message
      this.notificationBar.type = type   // 'success' or 'error'
      this.notificationBar.show = true
    }

  },
  created () {
    this.init()
  }
}
</script>
